function austin2014() {
    var cc = $.cookie('coupon_code'),
        tc = $.cookie('tracking_code');

    void 0;

    // set special codes if necessary
    if (!cc) {
        $.cookie('coupon_code', 'AUSTIN2014', { path:'/', domain:'.pop.co', expires: 7 });
    }

    if (!tc) {
        $.cookie('tracking_code', 'AUSTIN2014', { path:'/', domain:'.pop.co', expires: 7 });
    }
}
